import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useMutation } from "@apollo/client/react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { z } from "zod";
import { useAppDispatch } from "@/app/hooks";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Form } from "@/components/ui/form";
import { setCustomer } from "@/features/sessionSlice";
import { MutateCustomerDocument, UploadCustomerLogoDocument } from "@/gql/graphql";
import { settingsPath } from "@/routes";
import { RHFormInput } from "../forms/RHInput";
import { Input } from "../ui/input";
const customerSchema = z.object({
    name: z.string().min(3),
    attrs: z.object({}),
});
export default function CustomerCreateDialog({ onCompleted, open, onOpenChange }) {
    const [mutateCustomer, { loading }] = useMutation(MutateCustomerDocument, {
        refetchQueries: ["customers"],
    });
    const [uploadLogoMutation] = useMutation(UploadCustomerLogoDocument);
    const [selectedFile, setSelectedFile] = useState(null);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const form = useForm({
        resolver: zodResolver(customerSchema),
        defaultValues: { name: "", attrs: {} },
    });
    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setSelectedFile(e.target.files[0]);
        }
    };
    const onSubmit = async (values) => {
        try {
            const { data } = await mutateCustomer({ variables: { values } });
            if (!data?.mutateCustomer) {
                throw new Error("Mutation fehlgeschlagen!");
            }
            if (selectedFile) {
                const { data: uploadData } = await uploadLogoMutation({
                    variables: { customerId: data.mutateCustomer.id, fileName: "orginal" },
                });
                if (!uploadData?.uploadCustomerLogo) {
                    throw new Error("Keine Upload-URL erhalten!");
                }
                const { url } = uploadData.uploadCustomerLogo;
                const response = await fetch(url, {
                    method: "PUT",
                    headers: { "Content-Type": selectedFile.type },
                    body: selectedFile,
                });
                if (!response.ok) {
                    throw new Error("Logo Upload fehlgeschlagen!");
                }
            }
            onCompleted?.();
            form.reset();
            dispatch(setCustomer({ ...data.mutateCustomer, attrs: data.mutateCustomer.attrs }));
            navigate(settingsPath());
        }
        catch (e) {
            console.error(e);
        }
    };
    return (_jsx(Dialog, { open: open, onOpenChange: (state) => {
            onOpenChange?.(state);
            if (!state)
                form.reset();
        }, children: _jsxs(DialogContent, { children: [_jsx(DialogHeader, { children: _jsx(DialogTitle, { children: "Unternehmen erstellen" }) }), _jsx(Form, { ...form, children: _jsxs("form", { className: "space-y-4", onSubmit: form.handleSubmit(onSubmit), children: [_jsx(RHFormInput, { control: form.control, name: "name", label: "Name", placeholder: "Termitel" }), _jsxs("div", { className: "flex flex-col", children: [_jsx("label", { htmlFor: "logo", className: "mb-1 font-medium", children: "Unternehmenslogo" }), _jsx(Input, { id: "logo", type: "file", accept: "image/*", onChange: handleFileChange, className: "border rounded p-2" }), selectedFile && (_jsx("div", { className: "mt-2", children: _jsx("img", { src: URL.createObjectURL(selectedFile), alt: "Vorschau", className: "h-20 w-20 object-cover" }) }))] }), _jsx(DialogFooter, { children: _jsx(Button, { type: "submit", disabled: loading, children: "Speichern" }) })] }) })] }) }));
}
